import AppleHealthChartsWrapper from 'pages/Dashboard/components/AppleHealthChartsWrapper';
import React, { useEffect } from 'react';
import AppleHealthActivitySummaryChart, { DataKey } from 'pages/Dashboard/components/AppleHealthActivitySummaryChart';
import useWaypointData from 'pages/Dashboard/useWaypointData';
import Theme from 'theme';
import { TimeFrameOptions, waypointBarSizeMap } from 'pages/Dashboard/utils/trackingUtils';

interface SummaryChartProps{timeFrame: TimeFrameOptions;
    waypointId:string;
    patientId:string;
    providerId:string;
    title:string;
    subtitle:string;
    type:string;
    setCardStatus?: (type:string, v: boolean) => void;
    numberOfCards:number;
    setLoading?: (value:boolean) => void
    yAxisDefinition?: string;
    dataKey?: DataKey;
    unit?: string;}


function SummaryChart({
  patientId,
  providerId,
  waypointId,
  timeFrame,
  title,
  subtitle,
  yAxisDefinition,
  dataKey = DataKey.Steps,
  unit = 'Steps',
  type,
  setCardStatus,
  numberOfCards,
  setLoading,
} : SummaryChartProps) {
  const {
    sourceOptions,
    sourceId,
    onChangeSource,
    chartData,
    previousPeriodAverage,
    yAxisProps,
    isLoading = true,
    sourceObject,
    has6MonthData,
  } = useWaypointData({
    patientId,
    providerId,
    waypointId,
    timeFrame,
  });

  useEffect(() => {
    setCardStatus && setCardStatus(type, has6MonthData);
  }, [has6MonthData, setCardStatus, type]);
  useEffect(() => {
    setLoading?.(isLoading);
  }, [isLoading, setLoading]);
  return has6MonthData ? (
    <AppleHealthChartsWrapper
      timeFrame={timeFrame}
      title={title}
      subTitle={subtitle}
      gridSize={numberOfCards === 3 ? 4 : 6}
      hasMultipleItems
      isLoading={isLoading}
      headerIcon='directions_walk'
      key={waypointId}
      sourceObject={sourceObject}
      renderChart={(
        <AppleHealthActivitySummaryChart
          chartData={chartData}
          dataKey={dataKey}
          units={unit ?? ''}
          yAxisProps={yAxisProps}
          yAxisDefinition={yAxisDefinition ?? ''}
          previousPeriodAverage={previousPeriodAverage}
          showAverages={false}
          barSize={waypointBarSizeMap[`${timeFrame}-${4}`]}
          barColor={Theme.custom.colors.lightTertiaryMain}
          sourceId={sourceId}
          sourceOptions={sourceOptions}
          setSourceId={onChangeSource}
        />
  )}
    />
  ) : null;
}

export default SummaryChart;
